/**
 * @param  {} dataSource
 * @param  {} searchTerm
 * @param  {} searchProperty
 */
const filterHandler = (dataSource, searchTerm, searchProperty) => {
  if (Array.isArray(dataSource) && typeof searchProperty === 'string' && searchProperty) return dataSource == null ? void 0 : dataSource.filter(item => {
    var _item$searchProperty, _item$searchProperty$;

    return (_item$searchProperty = item[searchProperty]) == null ? void 0 : (_item$searchProperty$ = _item$searchProperty.toUpperCase()) == null ? void 0 : _item$searchProperty$.includes(searchTerm.toUpperCase());
  });
  return dataSource;
};
/**
 * @param  {} dataSource
 * @param  {} sortBy
 */


const sortByHandler = (dataSource, sortBy) => {
  return sortBy instanceof Function ? dataSource == null ? void 0 : dataSource.sort(sortBy) : dataSource;
};
/**
 * @param  {} {searchTerm
 * @param  {} dataSource
 * @param  {} sortBy
 * @param  {} searchProperty}
 *
 * Build list items with dataSource
 */


export default (({
  searchTerm,
  dataSource,
  sortBy,
  searchProperty
}) => sortByHandler(filterHandler(dataSource, searchTerm, searchProperty), sortBy));